module.exports = __webpack_public_path__ + "img/sky-strelki.377311b9.png";